module.exports = __webpack_public_path__ + "img/Logo_Flui3d.876a4d4a.svg";